import type { GetCreativeByIdQuery } from '../../../../apis/graphql';
import type { CreativeV5Types } from '../../CreativeBuilders/types';

export type GQLCreativeTypeProperties = GetCreativeByIdQuery['getCreativeByIDV5'];

type FieldKey = keyof CreativeV5Types;
export type CreativeTypeProperties = CreativeV5Types[FieldKey];

const gqlCreativeTypePropertiesToFieldKeyMap: Record<string, FieldKey> = {
  VIDEO: 'video',
  VAST_VIDEO: 'video',
  VPAID: 'video',
  SLATE: 'slate',
  // PREROLL_VIDEO: TBD,
  // PREROLL_VAST_VIDEO: TBD,
  // PREROLL_VPAID: TBD,
  BE_SELECTOR: 'poster',
  DISPLAY: 'image',
  GATEWAY: 'video',
  AD_SELECTOR: 'logo',
  // BRIGHTLINE: TBD,
  // INNOVID: TBD,
  PAUSE: 'image',
  MAGNITE: 'video',
  DRAX: 'video',
};

export const getFieldKey = (type?: string): FieldKey | '' => {
  if (!type) return '';

  return gqlCreativeTypePropertiesToFieldKeyMap[type];
};
